import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "store/types";

export const selectProjectDetails = (state: RootState) => state.projects.projectDetails;

export const selectProcessedData = createSelector([selectProjectDetails], (projectDetails) => projectDetails.processedData) 